<template>
  <div class="view">
    <Title title="メッセージ"/>
    <MessageMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import MessageMain from '@/components/MessageMain'

export default {
  components: {
    Title,
    MessageMain
  },

  created: function () {
    this.$store.dispatch('message/retrieveMessages')
  }
}
</script>
